export default {

    methods: {
        uploadBackground({ interactionId, advertisingId, file, isMobile }) {
            const data = new FormData()
            data.append('file', file)
            data.append('isMobile', isMobile)

            if (!file)
                return

            this.$api.interactions.background({interactionId, advertisingId, data, isMobile})
                .then(() => this.$loader.interactions.load(advertisingId))
        }
    },

}
